<template>
  <section>
    <h3 class="h-title">提交文件-主体文件</h3>  
    <el-form class="e-form f-b" ref="cForm3" :model="cForm3" label-width="auto"  label-position="left" :rules="setpFormRules3">
      <el-form-item class="w-70" label="三证合一" prop="threeCertOneFile">
        <el-upload
            class="upload-part"
            :limit="1"
            :action="action"
            :headers = "headers"
            :before-upload="(file) => beforeUpload(file)"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 'threeCertOneFile')"
            :on-success="(response, file, fileList) => upload(response, file, fileList, 'threeCertOneFile')" 
            :on-error="handleError"
            :file-list="cForm3.threeCertOneFile || []">
            <el-button size="small" type="orange">上传</el-button>
        </el-upload>
      </el-form-item> 
      <el-form-item class="w-70" label="法定代表人身份证" prop="identityCardFile">
        <el-upload
            class="upload-part"
            :limit="1"
            :action="action"
            :headers = "headers"
            :before-upload="(file) => beforeUpload(file)"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 'identityCardFile')"
            :on-success="(response, file, fileList) => upload(response, file, fileList, 'identityCardFile')" 
            :on-error="handleError"
            :file-list="cForm3.identityCardFile || []">
            <el-button size="small" type="orange">上传</el-button>
        </el-upload>
      </el-form-item> 
      <el-form-item class="w-70" label="公司简介" prop="companyProfileFile">
        <el-upload
            class="upload-part"
            :limit="1" 
            :action="action"
            :headers = "headers"
            :before-upload="(file) => beforeUpload(file)"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 'companyProfileFile')"
            :on-success="(response, file, fileList) => upload(response, file, fileList, 'companyProfileFile')" 
            :on-error="handleError"
            :file-list="cForm3.companyProfileFile || []">
            <el-button size="small" type="orange">上传</el-button>
        </el-upload>
      </el-form-item> 
      <el-form-item class="w-70" label="公司章程" prop="companyByelawFile">
        <el-upload
            class="upload-part"
            :limit="1"
            :action="action"
            :headers = "headers"
            :before-upload="(file) => beforeUpload(file)"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 'companyByelawFile')"
            :on-success="(response, file, fileList) => upload(response, file, fileList, 'companyByelawFile')" 
            :on-error="handleError"
            :file-list="cForm3.companyByelawFile || []">
            <el-button size="small" type="orange">上传</el-button>
        </el-upload>
      </el-form-item> 
      <el-form-item class="w-70" label="高管人员简历" prop="ggPersonResumeFile">
        <el-upload
            class="upload-part"
            :limit="1"
            :action="action"
            :headers = "headers"
            :before-upload="(file) => beforeUpload(file)"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 'ggPersonResumeFile')"
            :on-success="(response, file, fileList) => upload(response, file, fileList, 'ggPersonResumeFile')" 
            :on-error="handleError"
            :file-list="cForm3.ggPersonResumeFile || []">
            <el-button size="small" type="orange">上传</el-button>
        </el-upload>
      </el-form-item> 
      <el-form-item class="w-70" label="近两年财务报表及近一期财务报表" prop="financeReportFile">
        <el-upload
            class="upload-part"
            :limit="1"
            :action="action"
            :headers = "headers"
            :before-upload="(file) => beforeUpload(file)"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 'financeReportFile')"
            :on-success="(response, file, fileList) => upload(response, file, fileList, 'financeReportFile')" 
            :on-error="handleError"
            :file-list="cForm3.financeReportFile || []">
            <el-button size="small" type="orange">上传</el-button>
        </el-upload>
      </el-form-item> 
      <el-form-item class="w-70" label="灰名单查询结果" prop="riskResultFile" :rules="[{ type: 'array', required: true, message: '请上传', trigger: 'change' }]">
        <el-upload
            class="upload-part"
            :limit="1"
            :action="action"
            :headers = "headers"
            :before-upload="(file) => beforeUpload(file)"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 'riskResultFile')"
            :on-success="(response, file, fileList) => upload(response, file, fileList, 'riskResultFile')" 
            :on-error="handleError"
            :file-list="cForm3.riskResultFile || []">
            <el-button size="small" type="orange">上传</el-button>
        </el-upload>
      </el-form-item> 
      <el-form-item class="w-70" label="征信报告" prop="creditReportFile">
        <el-upload
            class="upload-part"
            :limit="1"
            :action="action"
            :headers = "headers"
            :before-upload="(file) => beforeUpload(file)"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 'creditReportFile')"
            :on-success="(response, file, fileList) => upload(response, file, fileList, 'creditReportFile')" 
            :on-error="handleError"
            :file-list="cForm3.creditReportFile || []">
            <el-button size="small" type="orange">上传</el-button>
        </el-upload>
      </el-form-item> 
      <el-form-item class="w-70" label="信用报告" prop="trustReportFile">
        <el-upload
            class="upload-part"
            :limit="1"
            :action="action"
            :headers = "headers"
            :before-upload="(file) => beforeUpload(file)"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 'trustReportFile')"
            :on-success="(response, file, fileList) => upload(response, file, fileList, 'trustReportFile')" 
            :on-error="handleError"
            :file-list="cForm3.trustReportFile || []">
            <el-button size="small" type="orange">上传</el-button>
        </el-upload>
      </el-form-item> 
    </el-form>
    <!-- 按钮 -->					
    <div class="cenrer">	
      <el-button class="s-but" type="orange" @click.native="prev">上一步</el-button>	
      <el-button class="s-but" type="orange" @click="cSubmitForm('0')" :loading="butLoading">保 存</el-button>
      <el-button class="s-but" type="orange" @click.native="cSubmitForm('1')" :loading="butLoading">下一步</el-button>
    </div>
  </section>
</template>
<script>
import baseUrl from '@/api/baseUrl.js'
import { elFormErrorScrollIntoView } from '@/utils/util'
export default {
    name: "step3",
    props: ["active"],
		data() {
			return { 
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("token")
        },      
        cForm3: {}, 
				setpFormRules3: {
          threeCertOneFile: [
							{ type: 'array', required: true, message: '请上传', trigger: 'change' }
          ],
          identityCardFile: [
							{ type: 'array', required: true, message: '请上传', trigger: 'change' }
          ],
          companyProfileFile: [
							{ type: 'array', required: true, message: '请上传', trigger: 'change' }
          ],
          companyByelawFile: [
							{ type: 'array', required: true, message: '请上传', trigger: 'change' }
          ],
          ggPersonResumeFile: [
							{ type: 'array', required: true, message: '请上传', trigger: 'change' }
          ],
          financeReportFile: [
							{ type: 'array', required: true, message: '请上传', trigger: 'change' }
          ],
          riskResultFile: [
							{ type: 'array', required: true, message: '请上传', trigger: 'change' }
          ],
        },
        action: '',
        butLoading: false,       
        account: sessionStorage.account,
        
			}
    },
    watch: {
      active(newVal) {
        if(newVal == 3) {
          this.action = `${baseUrl.iaccUrl}/iacc-contract-platform/common/uploadFile`;
          // this.action = `http://172.30.15.232:9097/common/uploadFile`;
          this.cForm3 = JSON.parse(sessionStorage.setpForm);
          this.cForm3.threeCertOneFile = JSON.parse(this.cForm3.threeCertOneFile) || [];
          this.cForm3.identityCardFile = JSON.parse(this.cForm3.identityCardFile) || [];
          this.cForm3.companyProfileFile = JSON.parse(this.cForm3.companyProfileFile) || [];
          this.cForm3.companyByelawFile = JSON.parse(this.cForm3.companyByelawFile) || [];
          this.cForm3.ggPersonResumeFile = JSON.parse(this.cForm3.ggPersonResumeFile) || [];
          this.cForm3.financeReportFile = JSON.parse(this.cForm3.financeReportFile) || [];
          this.cForm3.riskResultFile = JSON.parse(this.cForm3.riskResultFile || '[]');
          this.cForm3.creditReportFile = JSON.parse(this.cForm3.creditReportFile || '[]');
          this.cForm3.trustReportFile = JSON.parse(this.cForm3.trustReportFile || '[]');
        } 
      }
    },
    methods: {  
      fontData(){
        this.cForm3.threeCertOneFile = JSON.stringify(this.cForm3.threeCertOneFile||[]);
        this.cForm3.identityCardFile = JSON.stringify(this.cForm3.identityCardFile||[]);
        this.cForm3.companyProfileFile = JSON.stringify(this.cForm3.companyProfileFile||[]);
        this.cForm3.companyByelawFile = JSON.stringify(this.cForm3.companyByelawFile||[]);
        this.cForm3.ggPersonResumeFile = JSON.stringify(this.cForm3.ggPersonResumeFile||[]);
        this.cForm3.financeReportFile = JSON.stringify(this.cForm3.financeReportFile||[]);
        this.cForm3.riskResultFile = JSON.stringify(this.cForm3.riskResultFile||[]);
        this.cForm3.creditReportFile = JSON.stringify(this.cForm3.creditReportFile||[]);
        this.cForm3.trustReportFile = JSON.stringify(this.cForm3.trustReportFile||[]);
      },
      prev() {
        this.fontData()
        sessionStorage.setpForm = JSON.stringify(this.cForm3);
        this.$emit('prev')
      },
      cSubmitForm(type) {         
        
        if(type == '0'){
          this.fontData()
          this.butLoading = true;
          this.cForm3.status = '0'
          this.$api.consumer.addAndUpd(JSON.stringify(this.cForm3)).then(response => {
            this.butLoading = false;
            if(response.code == 200){
              sessionStorage.removeItem("setpForm")
              this.$message.success("保存成功");
              this.$router.go(-1);
            }     
          });
        }else{
          // 文件必填校验
          this.$refs["cForm3"].validate((valid) => {
            if ( valid ) {  
              this.fontData()
              sessionStorage.setpForm = JSON.stringify(this.cForm3);
              this.$emit('next');                        
            }else {
              this.$nextTick(() => {
                elFormErrorScrollIntoView()
              })
            }
          }) 
        }     
              
      },   
      handleError(err, file, fileList){
        this.$message.error(file.name + "文件上传失败");
      },
      beforeUpload(file) { 	
        const isLt2M = file.size / 1024 / 1024 <= 80     //这里做文件大小限制
        
        if(!isLt2M) {
          this.$message.error('上传文件大小不能超过 80MB！');
        }
        return isLt2M
      },
      upload(response, file, list, name){
          if(response.code == 200){
            this.$set(this.cForm3, name, [{
                name: response.name,
                url: response.url
              }])
              this.$refs.cForm3.clearValidate(name)
          }else{
            this.$set(this.cForm3, name,[])
            if(response.msg){
              this.$message.error(response.msg);
            }else {
              this.$message.error(file.name + "文件上传失败");
            }							
          }            
      },
      handleRemove(file, fileList, name) {
        this.$set(this.cForm3, name, [])

      },
    }
	}
</script>